<div class="loading-state">
  <div class="cards-container">
    @for (i of [1, 2, 3]; track i) {
      <div>
        <div class="map-section">
          <p-skeleton width="100%" height="100%"></p-skeleton>
        </div>
        <div class="content-section">
          <div class="card-header">
            <div class="geofence-info">
              <p-skeleton width="90%" height="1.5rem" [style]="{ 'margin-bottom': '12px' }"></p-skeleton>
              <p-skeleton width="100px" height="1.25rem"></p-skeleton>
            </div>
            <div class="card-actions">
              <p-skeleton
                width="32px"
                height="32px"
                [style]="{ 'border-radius': '4px', 'margin-right': '0.5rem' }"
              ></p-skeleton>
              <p-skeleton width="32px" height="32px" [style]="{ 'border-radius': '4px' }"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
